import { Component, Fragment } from "react"
import {
    DKLabel,
    DKInput,
    showToast,
    TOAST_TYPE,
    DKButton,
    showLoader,
    removeLoader,
    showAlert,
    DKIcon,
    DKIcons,
    DKLine
} from "deskera-ui-library";
import ic_arrow_back from "../../assets/icons/ic_arrow_back.svg";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { OvertimeService } from "./OvertimeService";
import Utility, { deepClone } from "../../utility/Utility";

import OvertimeGeneralSetting from "./OvertimeGeneralSetting";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
export default class OvertimeSummary extends Component {
    constructor(props) {
        super(props)
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
    }
    renderHeader() {
        return (
            <>
                <div className="row cursor-hand mb-m" onClick={()=>{
                    OvertimeService.setOvertimeData(null);
                    RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_LIST);
                    }}>
                    <DKIcon className="ic-s  " src={ic_arrow_back} />
                    <DKLabel text="Back to list" />
                </div>
                <div className="row justify-content-between">
                <DKLabel className="fw-m fs-l" text="Summary Setting" />
                <DKButton className="border-m bg-white" title="Edit" onClick={()=>{
                    const isShift = TenantService.get(TENANT.IS_SHIFT_MANAGEMENT_ENABLED);
                    if(isShift) {
                        if(!Utility.isEmpty(this.props.match.params.id)) {
                            RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_SETTING+"/"+this.props.match.params.id);
                        } else {
                            RouteManager.navigateToPage(PAGE_ROUTES.OVERTIME_LIST);
                        }
                    } else {
                        showAlert("Please Enable Shift Management","You have enable Shift Management for edit Overtime Policy.");
                    }
                   
                }}/>
                </div>
            </>
        )
    }
    render() {
        return (
            <Fragment>
                {this.renderHeader()}
                <OvertimeGeneralSetting {...this.props} isSummary={true}/>
            </Fragment>
        )
    }
}